'use client';

import { AllSubKeysMessageResource } from '@/i18n/messages';
import { cn } from '@/lib/utils';
import { LoginTarget } from '@/types/enum';
import { useTranslations } from 'next-intl';
import { Dispatch, memo, SetStateAction } from 'react';

interface Props {
    loginTarget: LoginTarget;
    setLoginTarget: Dispatch<SetStateAction<LoginTarget>>;

    disabled?: boolean;
}

interface ObjectSignIn {
    label: AllSubKeysMessageResource<'SignIn'>;
    value: LoginTarget;
}

/**
 * Danh sách đối tượng đăng nhập
 */
const ArrObjectSignIn: ObjectSignIn[] = [
    {
        label: 'Student',
        value: LoginTarget.UIS_Student,
    },
    {
        label: 'Staff',
        value: LoginTarget.Credential,
    },
    {
        label: 'Visitor',
        value: LoginTarget.Visitor,
    },
];

/**
 * Lựa chọn đối tượng đăng nhập
 */
export const ObjectSignIn = memo(
    ({ loginTarget, setLoginTarget, disabled }: Props) => {
        const transPage = useTranslations('SignIn');

        return (
            <div className='relative font-semibold flex select-none items-center overflow-hidden rounded-xl border bg-background text-foreground shadow-md'>
                {ArrObjectSignIn.map((obj) => (
                    <div
                        role='button'
                        key={obj.value}
                        className={cn(
                            'relative z-10 flex flex-1 items-center justify-center gap-x-1 p-2 outline-none transition-all focus-within:font-semibold',
                            {
                                'text-secondary-foreground':
                                    loginTarget === obj.value,
                                'cursor-default opacity-50': disabled,
                            }
                        )}
                        onClick={() => !disabled && setLoginTarget(obj.value)}
                    >
                        {transPage(obj.label)}
                    </div>
                ))}

                <div
                    className={cn(
                        'absolute inset-y-0 left-0 w-1/3 rounded-xl bg-secondary text-secondary-foreground transition-all',
                        {
                            'left-1/3': loginTarget === LoginTarget.Credential,
                            'left-2/3': loginTarget === LoginTarget.Visitor,
                        }
                    )}
                ></div>
            </div>
        );
    }
);

ObjectSignIn.displayName = 'ObjectSignIn';
